module.exports = __webpack_public_path__ + "static/media/Lifeguard Male.c87af3bf.jpg";